import React, { useEffect } from "react";
import FareButtons from "./Fare.Buttons";
import { SetBookingPayload } from "Pages/AvailableFaresPage";
import { AvailableFareModel } from "WebApiClient";
import { ServiceAddObj } from "./AncillariesModal";
import { AvailableFaresFare } from "components/AvailableFares/component/AvailableFares.Fares";

interface FareActionsProps {
    Fare: AvailableFareModel;
    BookFare?: (payload: SetBookingPayload) => void;
    IsFareBooking: boolean;
    SelectedConnections: number[];
    AddedServices: ServiceAddObj[];
    OnSelectConnection: (legindex: number, connectionIndex: number) => void;
    ToggleFlightTimes: () => void;
    ToggleRulesModal: () => void;
    ToggleAncillariesModal: () => void;
    ToggleFlightDetailsModal: () => void;
    ToggleCalculationDebug: () => void;
    ToggleCalculation: () => void;
    ShowCalcDebug: boolean;
    UpscaleCalculation: (data: any[], source: string) => void;
    upSaleToggle: boolean;
    showLegs: boolean;
    upscaleFilterData: AvailableFaresFare[];
    setupSaleToggle: React.Dispatch<React.SetStateAction<boolean>>;
    isFlightTimesOpen: boolean;
}

const FareActions: React.FC<FareActionsProps> = ({
    Fare,
    BookFare,
    IsFareBooking,
    SelectedConnections,
    AddedServices,
    OnSelectConnection,
    ToggleFlightTimes,
    ToggleRulesModal,
    ToggleAncillariesModal,
    ToggleFlightDetailsModal,
    ToggleCalculationDebug,
    ToggleCalculation,
    ShowCalcDebug,
    UpscaleCalculation,
    upSaleToggle,
    showLegs,
    upscaleFilterData,
    setupSaleToggle,
    isFlightTimesOpen
}) => {

    const handleBookFare = () => {
        if (BookFare && !IsFareBooking) {
            const payload: SetBookingPayload = {
                Fare,
                SelectedConnections,
                AddedServices,
                OnSelectConnection,
            };
            BookFare(payload);
        }
    };

    // Move upscale logic here
    function matchConnIndex(leg: any, targetIndex: number) {
        return leg?.connections.findIndex((conn: any) => conn.index === targetIndex);
    }

    function handleUpscale(source: string) {
        const upscalePropertyArray: any = [];

        Fare.legs.forEach((leg, index) => {
            const flightNumbers: any[] = [];
            const connIndex = matchConnIndex(leg, SelectedConnections[index]);

            leg?.connections[connIndex]?.segments.forEach((segment: any) => {
                flightNumbers.push({ flightNumber: segment.flightNumber, legNumber: index });
            });

            upscalePropertyArray.push({
                code: leg?.platingCarrier?.code,
                arrivalDisplayTime: leg?.connections[connIndex]?.connectionHeader?.arrivalDisplayTime,
                departureDisplayTime: leg?.connections[connIndex]?.connectionHeader?.departureDisplayTime,
                codeNumber: flightNumbers,
                fareIndex: Fare.fareIndex,
            });
        });

        UpscaleCalculation(upscalePropertyArray, source);
    }

    useEffect(() => {
        if (upSaleToggle || showLegs) {
            handleUpscale("connectionTriggeredLeg");
        }
    }, [SelectedConnections, showLegs]); // react will auto detect needed deps

    return (
        <FareButtons
            ToggleFlightTimes={ToggleFlightTimes}
            ToggleRulesModal={ToggleRulesModal}
            ToggleAncillariesModal={ToggleAncillariesModal}
            ToggleFlightDetailsModal={ToggleFlightDetailsModal}
            ToggleCalculationDebug={ToggleCalculationDebug}
            ToggleCalculation={ToggleCalculation}
            ShowCalcDebug={ShowCalcDebug}
            BookFare={handleBookFare}
            IsFareBooking={IsFareBooking}
            SelectedConnections={SelectedConnections}
            Identifier={Fare.identifier!}
            Fare={Fare}
            UpscaleCalculation={UpscaleCalculation}
            upSaleToggle={upSaleToggle}
            showLegs={showLegs}
            upscaleFilterData={upscaleFilterData}
            setupSaleToggle={setupSaleToggle}
            isFlightTimesOpen={isFlightTimesOpen}
        />
    );
};

export default FareActions;
